import React from 'react'

import { Avatar } from '@fourthwall/components'

import * as S from './styled'
import type { Props } from './types'

export const SupporterCell = ({ name, avatarUrl, shadowBanned }: Props) => {
  const getAvatar = () => {
    if (!avatarUrl) return

    return avatarUrl
  }

  return (
    <S.Container>
      <S.AvatarContainer>
        <Avatar name={name} imageUrl={getAvatar()} />
      </S.AvatarContainer>
      <div>
        <S.Name>{name}</S.Name>
        {shadowBanned && <S.Info>Shadowbanned</S.Info>}
      </div>
    </S.Container>
  )
}
